import { render, staticRenderFns } from "./PriceCompareRuleDialog.vue?vue&type=template&id=6da1c450&scoped=true&"
import script from "./PriceCompareRuleDialog.vue?vue&type=script&lang=js&"
export * from "./PriceCompareRuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./PriceCompareRuleDialog.vue?vue&type=style&index=0&id=6da1c450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1c450",
  null
  
)

export default component.exports